export enum CacheKey {
  RedirectAfterCompleteProfileUrl = 'redirect_after_complete_profile_url',
  RedirectToGameFromChatUrl = 'redirect_to_game_from_chat_url'
}
